const state = {
    mobileMenu: false
}

const getters = {
    mobileMenu: (state) => {
        return state.mobileMenu
    }
}
const actions = {
    mobileMenu(context, mobileMenu){
        context.commit('mobileMenu', mobileMenu);
    }
}

const mutations = {
    mobileMenu(state, mobileMenu){
        state.mobileMenu = mobileMenu;
    }
}

export default {
     state,
     getters,
     actions,
     mutations
 }